import { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { MaskLine, Reveal } from "./Reveal";
import { SUPPLIERS } from "../../lib/data";

const domainOf = (url) => {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return "";
  }
};

const LogoTile = ({ s, i }) => {
  const [ok, setOk] = useState(true);
  const domain = domainOf(s.url);
  return (
    <Reveal delay={i * 0.06} className="h-full">
      <a
        href={s.url}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`supplier-link-${i}`}
        className="group relative flex flex-col items-center justify-center gap-4 h-40 sm:h-44 bg-paper border border-ink/15 p-5 hover:border-redx transition-colors duration-300"
      >
        <ArrowUpRight
          size={16}
          className="absolute top-3 right-3 text-ink/30 group-hover:text-redx group-hover:rotate-45 transition-all duration-300"
        />
        <div className="h-14 w-14 flex items-center justify-center">
          {ok ? (
            <img
              src={`https://www.google.com/s2/favicons?domain=${domain}&sz=128`}
              alt={`${s.name} logo`}
              onError={() => setOk(false)}
              className="max-h-12 max-w-12 object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
              data-testid={`supplier-logo-${i}`}
            />
          ) : (
            <span className="font-oswald text-4xl text-ink group-hover:text-redx transition-colors">
              {s.name.charAt(0)}
            </span>
          )}
        </div>
        <div className="text-center">
          <div className="font-oswald uppercase text-sm sm:text-base tracking-tight text-ink leading-tight">{s.name}</div>
          <div className="font-oswald uppercase text-[0.6rem] tracking-widest text-ink/45 mt-1">{s.tag}</div>
        </div>
      </a>
    </Reveal>
  );
};

export const Leverandorer = () => (
  <section id="leverandorer" className="bg-bone py-24 sm:py-32" data-testid="leverandorer-section">
    <div className="max-w-[1600px] mx-auto px-5 sm:px-8">
      <div className="grid grid-cols-12 gap-6 mb-14 sm:mb-20">
        <div className="col-span-12 lg:col-span-7">
          <Reveal>
            <span className="font-oswald uppercase text-xs tracking-[0.3em] text-redx">Våre leverandører</span>
          </Reveal>
          <h2 className="font-oswald font-bold uppercase tracking-tight leading-[0.9] text-5xl sm:text-7xl mt-4 text-ink">
            <MaskLine>Kvalitets-</MaskLine>
            <MaskLine delay={0.1}>merker vi står bak</MaskLine>
          </h2>
        </div>
        <div className="col-span-12 lg:col-span-5 lg:pt-4">
          <Reveal delay={0.2}>
            <p className="text-ink/60 leading-relaxed max-w-md">
              Som sertifisert partner leverer vi utstyr fra bransjens ledende produsenter. Trykk på et merke for å utforske sortimentet.
            </p>
          </Reveal>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 sm:gap-6">
        {SUPPLIERS.map((s, i) => (
          <LogoTile key={s.name} s={s} i={i} />
        ))}
      </div>
    </div>
  </section>
);
